const config = {
  url: '/tags',
  title: 'Теги',
  endpoint: '/admin-search?filter=tags',
  type: 'table',
  getUrl: id => `/tag/${id}`,
  getApiUrl: id => `/tags/${id}`,
  search: true,
  key: 'tags',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
